module.exports = __webpack_public_path__ + "img/bg.62615669.jpg";